import React, {useEffect, useRef, useState} from "react";
import {Form, InputGroup, Button} from "react-bootstrap";

const TicketsSearch = ({ value, onDebouncedChange, isLoading, placeholder = "Search Ticket" }) => {
    const [local, setLocal] = useState(value ?? "");
    const typingRef = useRef(false);

    useEffect(() => {
        if(!typingRef.current) {
            setLocal(value ?? "");
        }
    }, [value]);

    useEffect(() => {
        typingRef.current = true;

        const id = setTimeout(() => {
            typingRef.current = false;
            onDebouncedChange(local);
        }, 400);

        return () => clearTimeout(id);
    }, [local, onDebouncedChange]);
    return (
        <InputGroup style={{maxWidth: 320}}>
            <Form.Control
                value = {local}
                onChange={(e) =>setLocal(e.target.value)}
                placeholder={placeholder}
                className="ticket-search-input"
            />
            {local?.length > 0 &&  ( 
            <Button
                className="ticket-search-button"
                variant="outline-secondary" 
                onClick={() => setLocal("")}
                disabled={isLoading}
            >
                Clear
            </Button>
            )}
        </InputGroup>
    );
};

export default TicketsSearch;